/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';
import castArray from 'lodash/castArray';
import FieldContext from 'rc-field-form/es/FieldContext';

import { Form } from '@organisms';
import { ErrorMessage } from '@atoms';

import s from './styles.module.less';
import { FORM_FIELD } from './constants';
import ListItem from './ListItem';

const VocabularyFields = ({ name, form }) => {
  const { prefixName = [], getFieldValue } = React.useContext(FieldContext);
  const formName = React.useMemo(() => {
    return [...prefixName, ...castArray(name)];
  }, [prefixName, name]);

  return (
    <Form.List name={name}>
      {(fields) => {
        return (
          <>
            {fields.map((field, index) => {
              const value = getFieldValue([...formName, field.name]);
              const key = `${formName.join('.')}-${field.key}`;
              return (
                <div index={index} key={key}>
                  <ListItem vocabulary={value} form={form} field={field} />
                </div>
              );
            })}
          </>
        );
      }}
    </Form.List>
  );
};
const VocabularyForm = ({ initialValues = {}, error, form, languageCode }) => {
  return (
    <Form form={form} layout="vertical" initialValues={initialValues}>
      <ErrorMessage error={error} variant="block" spaced />
      <div className={clsx(s.line)}>
        <div className={clsx(s.element, s.blockElement)}>KEY:</div>
        <div className={clsx(s.element, s.blockSecondElement)}>{languageCode?.toUpperCase()}:</div>
      </div>
      <VocabularyFields {...FORM_FIELD.VOCABULARIES} form={form} />
    </Form>
  );
};

VocabularyForm.useForm = () => Form.useForm(FORM_FIELD);

export default VocabularyForm;
